import { ZodError, ZodFormattedError } from 'zod';

const REQUIRED_ZOD_KEY = 'Required';

const hasRequiredError = (errorSchema: ZodError<{ [key: string]: unknown }>, propertyName: string) => {
    const formattedErrorSchema = errorSchema.format();

    return !!(formattedErrorSchema[propertyName] as ZodFormattedError<unknown>)?._errors.includes(REQUIRED_ZOD_KEY);
};

export const SchemaHelpers = {
    hasRequiredError,
};
